import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createPickupLocationAsync, updatePickupLocationAsync, getAllPickupLocationsAsync, getPickupLocationByIdAsync, deletePickupLocationAsync, getPickupLocationsNotPaginatedByEventIdAsync, ClosePickUpLocationAsync, checkPickupLocationAvailabilityAsync, getTransportDashboardSummaryAsync, getTransportDashboardTrendAsync, getMapsKeyAsync } from './pickupLocationThunk';
const initialState = {
    status: APIStatus.IDLE,
    pickupLocations: null,
    pickupLocation: undefined,
    pickupLocationsList: null,
    pickupLocationResponse: undefined,
    isPickupLocationClosed: undefined,
    transportDashboardSummary: undefined,
    transportDashboardTrend: undefined,
    transportDashboardSummaryStatus: APIStatus.IDLE,
    transportDashboardTrendStatus: APIStatus.IDLE,
    mapsKey: undefined,
    mapsKeyStatus: APIStatus.IDLE
};
export const pickupLocationSlice = createSlice({
    name: 'pickupLocation',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createPickupLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createPickupLocationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.pickupLocation = action.payload;
        })
            .addCase(createPickupLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updatePickupLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updatePickupLocationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.pickupLocation = action.payload;
        })
            .addCase(updatePickupLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllPickupLocationsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllPickupLocationsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.pickupLocations = action.payload;
        })
            .addCase(getAllPickupLocationsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getPickupLocationByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPickupLocationByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.pickupLocation = action.payload;
        })
            .addCase(getPickupLocationByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deletePickupLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deletePickupLocationAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deletePickupLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getPickupLocationsNotPaginatedByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPickupLocationsNotPaginatedByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.pickupLocationsList = action.payload;
        })
            .addCase(getPickupLocationsNotPaginatedByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(ClosePickUpLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(ClosePickUpLocationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.pickupLocationResponse = action.payload;
        })
            .addCase(ClosePickUpLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(checkPickupLocationAvailabilityAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(checkPickupLocationAvailabilityAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.isPickupLocationClosed = action.payload.data;
        })
            .addCase(checkPickupLocationAvailabilityAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getTransportDashboardSummaryAsync.pending, (state) => {
            state.transportDashboardSummaryStatus = APIStatus.PENDING;
        })
            .addCase(getTransportDashboardSummaryAsync.fulfilled, (state, action) => {
            state.transportDashboardSummaryStatus = APIStatus.SUCCESS;
            state.transportDashboardSummary = action.payload;
        })
            .addCase(getTransportDashboardSummaryAsync.rejected, (state, action) => {
            state.transportDashboardSummaryStatus = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getTransportDashboardTrendAsync.pending, (state) => {
            state.transportDashboardTrendStatus = APIStatus.PENDING;
        })
            .addCase(getTransportDashboardTrendAsync.fulfilled, (state, action) => {
            state.transportDashboardTrendStatus = APIStatus.SUCCESS;
            state.transportDashboardTrend = action.payload;
        })
            .addCase(getTransportDashboardTrendAsync.rejected, (state, action) => {
            state.transportDashboardTrendStatus = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getMapsKeyAsync.pending, (state) => {
            state.mapsKeyStatus = APIStatus.PENDING;
        })
            .addCase(getMapsKeyAsync.fulfilled, (state, action) => {
            state.mapsKeyStatus = APIStatus.SUCCESS;
            state.mapsKey = action.payload;
        })
            .addCase(getMapsKeyAsync.rejected, (state, action) => {
            state.mapsKeyStatus = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default pickupLocationSlice.reducer;
